import React from 'react';
import { cn } from '@/lib/utils';

interface UserMessageProps {
  content: string;
  className?: string;
}

export const UserMessage = React.memo<UserMessageProps>(({ content, className }) => {
  return (
    <div className={cn("flex justify-end mb-4", className)}>
      <div className="max-w-[80%] rounded-2xl px-4 py-2 bg-[var(--chat-bubble-color)] text-white">
        <p className="text-sm whitespace-pre-wrap break-words">{content}</p>
      </div>
    </div>
  );
});
UserMessage.displayName = 'UserMessage';

